import PropTypes from 'prop-types'
import { useMemo } from 'react'
import {
  Autocomplete as MUIAutocomplete,
  CircularProgress,
  ListItem,
  TextField,
  Typography,
} from '@mui/material'
import { useOrgsWithProjects } from '../../graphql/projectLookupQueries'

const ProjectAutocomplete = ({ value, onChange, disabled }) => {
  const { orgs: orgList, loading } = useOrgsWithProjects()

  const options = useMemo(() => {
    return orgList.flatMap((org) =>
      (org.projectList?.projects || []).map((project) => ({
        id: project.id,
        title: project.title,
        orgName: org.displayName,
      })),
    )
  }, [orgList])

  const selectedOption = useMemo(
    () => options.find((o) => o.id === value) || null,
    [options, value],
  )

  return (
    <MUIAutocomplete
      options={options}
      value={selectedOption}
      loading={loading}
      disabled={disabled}
      size="small"
      getOptionLabel={(opt) => opt.title ?? ''}
      isOptionEqualToValue={(opt, val) => opt.id === val.id}
      onChange={(_, newValue) => onChange(newValue?.id ?? null)}
      noOptionsText="No results found"
      openOnFocus
      renderInput={(params) => (
        <TextField
          {...params}
          label="Project"
          required
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={16} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      renderOption={(props, opt) => (
        <ListItem {...props} key={opt.id}>
          <div>
            <Typography variant="body2">{opt.title}</Typography>
            <Typography variant="caption" color="text.secondary">
              {opt.orgName} &middot; {opt.id}
            </Typography>
          </div>
        </ListItem>
      )}
    />
  )
}

ProjectAutocomplete.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default ProjectAutocomplete
